<template>
  <BaseDialog
    v-model="dialog"
    :persistent="!!loading"
    :loading="!!loading"
    max-width="500"
    title="Import Workorders"
  >
    <FileField
      v-model="file"
      :disabled="!!loading"
      variant="outlined"
      density="compact"
    />
    <template #actions>
      <v-btn
        color="primary"
        :loading="!!loading"
        flat
        :disabled="file === null"
        @click="upload"
        >Import</v-btn
      >
    </template>
  </BaseDialog>
</template>

<script setup lang="ts">
import { ref } from "vue";
import BaseDialog from "../base/dialogs/BaseDialog.vue";
import FileField from "../base/inputs/FileField.vue";
import { Workorder, DBFile } from "@/classes";
import { setupApiQueue } from "../base/api-queue";

const dialog = ref(false);
const file = ref<DBFile | null>(null);

const open = () => {
  dialog.value = true;
};

const emit = defineEmits(["imported"]);

defineExpose({ open });

const { queueApiAction, loading } = setupApiQueue();

const upload = () => {
  queueApiAction(async () => {
    if (file.value !== null) {
      await Workorder.importList(file.value.id);
      emit("imported");
    }
  });
};
</script>
